module.exports = __webpack_public_path__ + "static/media/link.ad2fb5ee.svg";